// ** React Imports
import { useState, useEffect } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import { useWizard } from "react-use-wizard";

// ** Custom Components
import ProgressBar from "../ProgressBar";
import NextButton from "../NextButton";
import StepLabel from "../StepLabel";
import GenderContent from "./GenderContent";
import ErrorMessage from "containers/Landing/components/ErrorMessage";

// ** Styled Components
import {
	StyledContentWrapper,
	StyledButtonWrapper,
	StyledNextButtonContainer,
} from "containers/Landing/containers/Register/styles";

// #####################################################

const StepGender = ({
	currentStep,
	totalSteps,
	oAuth,
	setOAuth,
	setShowContinueWithOAuthButton,
}) => {
	const { t } = useTranslation(["common", "landing"]);

	const selectedGender = useSelector(
		(state) => state.auth.register.registerForm.gender.gender
	);

	const [showGenderEmptyMessage, setShowGenderEmptyMessage] = useState(false);

	const { nextStep, goToStep } = useWizard();

	useEffect(() => {
		if (oAuth.reset) {
			goToStep(0);
			setOAuth((prev) => ({ ...prev, reset: false }));
		}
		setShowContinueWithOAuthButton(true);
	}, [oAuth.reset]);

	// #####################################################

	return (
		<>
			<StyledContentWrapper>
				{/* Nagłówek */}
				<StepLabel label={t("landing:register.selectGender")} />

				{/* Główna Zawartość Kroku */}
				<GenderContent
					selectedGender={selectedGender}
					setShowGenderEmptyMessage={setShowGenderEmptyMessage}
				/>
			</StyledContentWrapper>

			{/* Komunikaty Błędów */}
			{showGenderEmptyMessage && (
				<ErrorMessage>
					{t("landing:register.selectGenderEmpty")}
				</ErrorMessage>
			)}

			{/* Pasek Postępu */}
			<ProgressBar currentStep={currentStep} totalSteps={totalSteps} />

			{/* Przyciski "Next" && "Prev" */}
			<StyledButtonWrapper flex>
				<StyledNextButtonContainer withoutBackButton>
					<NextButton
						onClick={() => {
							if (!selectedGender) {
								setShowGenderEmptyMessage(true);
							} else {
								nextStep();
							}
						}}
					/>
				</StyledNextButtonContainer>
			</StyledButtonWrapper>
		</>
	);
};

// #####################################################

export default StepGender;

// #####################################################
